var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canEdit(_vm.item.userId._id))?_c('div',[_c('v-btn',{attrs:{"rounded":"","small":_vm.small,"color":"success","block":_vm.isMobilePort},on:{"click":function($event){return _vm.add()}}},[_vm._v(" Add Album ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }